export function assertExhaustive(
  value: never,
  message: string = 'Reached unexpected case in exhaustive switch',
): never {
  throw new Error(message)
}

export const hasAnyValues = (obj: any) => {
  return (
    obj &&
    Object.keys(obj).some((key) => obj[key as keyof typeof obj] !== undefined)
  )
}

export const isNumber = (value: any): value is number => {
  return typeof value === 'number' && !isNaN(value)
}

export const isFiniteNumber = (value: any): value is number => {
  return isNumber(value) && isFinite(value)
}

/* Get initial string */
export const getShortAvatarName = (avatarName: string) => {
  const trimmed = avatarName.trim()
  if (!trimmed) return ''

  const nameParts = trimmed.split(/[\s-]/)
  const firstInitial = nameParts[0]?.[0] || ''
  const secondInitial = nameParts[1]?.[0] || nameParts[0]?.[1] || ''

  return (firstInitial + secondInitial).toUpperCase()
}
